import Home from "./Home";
import GettingStarted from "./GettingStarted";
import ActivityIndicator from "./ActivityIndicator";
import Alert from "./Alert";
import Text from "./Text";
import TextInput from "./TextInput";
import Image from "./Image";
export {
  Home,
  GettingStarted,
  ActivityIndicator,
  Alert,
  Text,
  TextInput,
  Image
};
